import { MixerProvider } from './context/MixerContext';
import MixerControls from './components/MixerControls';
import ContentArea from './components/ContentArea';
import './App.css';

function App() {
  return (
    <MixerProvider>
      <div className="app">
        <div className="app__layout">
          <aside className="app__sidebar">
            <MixerControls />
          </aside>
          <ContentArea />
        </div>
        <footer className="app__footer">
          <span>Tom Keech</span>
          <span className="app__footer-divider">·</span>
          <span>Career Mixer</span>
          <span className="app__footer-divider">·</span>
          <span>2025</span>
        </footer>
      </div>
    </MixerProvider>
  );
}

export default App;
